module.exports = __webpack_public_path__ + "img/logo-7.a097b938.svg";